import React from 'react'
import { Image } from '../../Image/Image'
import styles from '.././CheckoutForm.module.css'
import { Customer } from './CustomerInfo'
import { formatPhoneNumber } from '../../../utils/phone-utils'

interface Props {
  customer: Customer
  companyName?: string | null
}

export const CompletedCustomerInfo = ({ customer, companyName }: Props) => {
  const formattedPhoneNumber = formatPhoneNumber(
    customer.phone,
    customer.phoneCountryCode
  )

  const email = customer.email
  const firstName = customer.firstName
  const lastName = customer.lastName

  return (
    <div data-testid='completed-customer-info'>
      {firstName && lastName && (
        <div className='flex pb-2'>
          <div className={styles.icon}>
            <Image
              alt='Customer icon'
              path='icons/user-gray.svg'
              className={''}
            />
          </div>
          {firstName} {lastName}
        </div>
      )}
      {email && (
        <div className='flex pb-2'>
          <div className={styles.icon}>
            <Image alt='Email icon' path='icons/email-gray.svg' />
          </div>
          {email}
        </div>
      )}
      {formattedPhoneNumber && (
        <div className='flex pb-2'>
          <div className={styles.icon}>
            <Image alt='Phone icon' path='icons/phone-gray.svg' />
          </div>
          {formattedPhoneNumber}
        </div>
      )}
      {companyName && (
        <div className='flex pb-2'>
          <div className={styles.icon}></div>
          {companyName}
        </div>
      )}
    </div>
  )
}
